module.exports = __webpack_public_path__ + "media/components/stylesheets/BrandonText-RegularItalic-afc052353d4db7c3a591d998fe0f3749.woff";